export const enum AsyncDataKeys {
  // Filters
  FILTER_OPTIONS = 'filter-options',

  // Branch
  BRANCH_DETAIL = 'branch-detail',
  BRANCH_MENU_ITEM = 'branch-menu-item',
  BRANCH_HEADCOUNT = 'branch-headcount',
  BRANCH_ARRIVAL_TIMES = 'branch-arrival-times',
  BRANCH_REVIEW_SUMMARY = 'branch-review-summary',
  BRANCH_PAA = 'branch-paa',

  // Order
  ORDER_DETAIL = 'order-detail',
  ORDER_ATTENDANCE_STATUS = 'order-attendance-status',
  ORDER_ATTENDANCE_REASONS = 'order-attendance-reasons',
  MEMBER_ORDERS = 'member-orders',

  // Member
  MEMBER_DELETION = 'member-deletion',

  // Region
  REGION = 'region',
  REGION_DISCOUNT_PRODUCTS = 'region-discount-products',
  REGION_POPULAR_PRODUCTS = 'region-popular-products',
  REGION_OTHER_CITIES = 'region-other-cities',

  // Category
  CATEGORY = 'category',

  // Product
  PRODUCT_LIST = 'product-list',
  PRODUCT_COMMENTS = 'product-comments',
  PRODUCT_REVIEW_TAGS = 'product-review-tags',
  PRODUCT_REVIEW_TAGS_COUNT = 'product-review-tags-count',
  PRODUCT_REMARKS = 'product-remarks',
  PROMO_TAGS = 'promo-tags',

  // Restaurant
  RESTAURANT_COUNT = 'restaurant-count',

  // Promo
  PROMO_CODES = 'promo-codes',
  RECOMMENDED_PROMO = 'recommended-promo',

  // Search
  SEARCH_POPULAR_KEYWORDS = 'search-popular-keywords',
  SEARCH_SUGGESTIONS = 'search-suggestions',
}

export const getAsyncDataKey = (baseKey: string, params: (string | number | undefined)[] = []) => `${baseKey}_${params.filter(Boolean).join('_')}`
